import React, {useState, useEffect} from "react";
import {motion, AnimatePresence} from 'framer-motion'
import {pageAnimation} from '../Variants/variants'
import { letterSlide } from "../Variants/contactVariants";
import '../CSS/Contact.scss'
import '../CSS/ContactLetterOpen.scss'
import ContactClosed from "./ContactClosed";
import ContactOpened from "./ContactOpened";
import ContactSend from './ContactSend';

function Contact(){
    const [isFront, setIsFront] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [delaySent, setDelaySent] = useState(false);
    const [sent, isSent] = useState(false);

    const clicked = () =>{
        setIsFront(!isFront)
    }

    useEffect(() =>{
        if(delaySent){
            setTimeout(() => {
                isSent(true)
            }, 600);
        }
    }, [delaySent])

    return(
        <motion.div 
        className="contact-container"
        variants={pageAnimation}
        initial="initial"
        animate="animate"
        exit="exit">
            {!sent && (
                <motion.div className="envelope-container"
                variants={letterSlide}
                initial='initial'
                animate='animate'>
                    <motion.div className={`letter ${isFront ? "active" : ""}`}
                    style={{visibility: isOpen ? "hidden" : "visible"}}
                    layout>
                        <motion.div className="letter-front">
                            <div className="stamp"></div>
                            <h1>To Jimmy</h1>
                            <span>(jimwoo030@gmail.com)</span>
                            <motion.h2
                            onClick={() => clicked()}>Flip Over</motion.h2>
                        </motion.div>
                        <motion.div className="letter-back">
                            <AnimatePresence mode="wait">
                                {!isOpen && (
                                    <ContactClosed setIsOpen={setIsOpen} isFront={isFront} setIsFront={setIsFront} key='seal'/>
                                )}
                            </AnimatePresence>
                        </motion.div>
                    </motion.div>
                    
                    <AnimatePresence mode="wait">
                        {isOpen && (
                            <ContactOpened key='letter' setIsOpen={setIsOpen} setDelaySent={setDelaySent}/>
                        )}
                    </AnimatePresence>
                </motion.div>
            )}
            {sent && (
                <motion.div className="envelope-container">
                    <motion.div className="letter-sent"
                        animate={{scale: [1, .3, .3, .3, .3], 
                        scaleX: [1, 1, 1, .5, .4, .4, 1.4, 1.6], 
                        rotate: [0, 0, 25, 25, 0, 0],
                        x: ["0%", "0%", "-50%", "-60%","150%"],
                        times: [0, 0.8, .85, .9, 1]}}
                        transition={{ease: 'linear', duration: 1.25}}
                        onAnimationComplete={() => setTimeout(() => {
                            isSent(false);
                            setIsFront(false)
                            setDelaySent(false)
                        }, 1000)}>
                        <motion.div className="letter-sent-back"
                        >
                            <ContactSend/>
                        </motion.div>
                    </motion.div>
                </motion.div>
            )}
        </motion.div>
    )
}

export default Contact;